import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const faqData = [
  {
    question: 'Do you offer emergency services?',
    answer: 'Yes, we provide 24/7 plumbing & heating support throughout Yarmouth NS and surrounding areas. Call us anytime at 902-746-0554 for emergency assistance.',
  },
  {
    question: 'Are you licensed and insured?',
    answer: 'Yes, all our work is performed by licensed journeymen plumbers. We are fully insured for your peace of mind and protection.',
  },
  {
    question: 'What areas do you serve?',
    answer: 'We proudly serve Yarmouth, Digby and Shelburne Counties.',
  },
  {
    question: 'Do you handle electric boilers & in-floor heating?',
    answer: 'Yes, we specialize in electric boiler installation, repair, and maintenance, as well as in-floor heating systems for both residential and light commercial properties.',
  },
  {
    question: 'Do you provide water filtration services?',
    answer: 'Yes, we offer complete water filtration solutions including installation, maintenance, and servicing to ensure clean, safe water for your home or business.',
  },
];

export const FAQ = ({ className = '' }) => {
  return (
    <section className={`${className}`} data-testid="faq-section">
      <Accordion type="single" collapsible className="w-full">
        {faqData.map((item, index) => (
          <AccordionItem
            key={index}
            value={`item-${index}`}
            className="border-b border-slate-200 last:border-b-0"
          >
            <AccordionTrigger
              data-testid={`faq-question-${index}`}
              className="text-left font-semibold text-gray-900 hover:text-[#005B96] py-5 text-lg"
            >
              {item.question}
            </AccordionTrigger>
            <AccordionContent
              data-testid={`faq-answer-${index}`}
              className="text-gray-600 pb-5 leading-relaxed"
            >
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export default FAQ;
